import React, {useState, useEffect} from 'react';
import styles from "../../assets/stylesheets/sass/Translations.module.scss"
import edit_icon from "../../assets/icons/edit.svg"
import view_icon from "../../assets/icons/view.svg";
import Dropdownlist from '../customComponents/Dropdownlist';

export default function Translations(){

    let contentPages = {
        "admin": {
            "Login": {
                "Login": true
            },
            "FormError": {
                "FormError": true
            },
            "ForgotPassword": {
                "ForgotPassword": true
            },
            "ResetPassword": {
                "ResetPassword": true
            },
            "Register": {
                "Register": true
            },
            "Dashboard": {
                "Dashboard": true
            },
            "Files": {
                "Files": true
            },
            "Documents": {
                "Documents": true
            },
            "UserManagement": {
                "UserManagement": true
            },
            "General": {
                "General": true
            },
            "Invoices": {
                "Invoices": true
            },
            "WeighingTickets": {
                "WeighingTickets": true
            },
            "UserGroups": {
                "UserGroups": true
            }
        }
    };

    const [pageToEdit, setpageToEdit] = useState("");
    const [hideContent, sethideContent] = useState(false);
    const [showAddForm, setshowAddForm] = useState(false);
    const [settingsLanguage, setsettingsLanguage] = useState("N");

    const [attribute_name, setattribute_name] = useState("");
    const [attribute_text, setattribute_text] = useState("");

    const [content_state, setcontent_state] = useState();
    const [data_isSaved, setdata_isSaved] = useState(false);

    const [showSaveWarning, setshowSaveWarning] = useState(false);
    

    const handleClickPage = (e) =>{
        setpageToEdit(e.currentTarget.id);
    }

    useEffect(()=>{
        const fetchData = async () =>{
           const data = await fetch(process.env.REACT_APP_SERVER_LINK+"content");
           let res = await data.json();
           setcontent_state(res);

            if(!res.KEYS[pageToEdit]){
                let tmp_content = {...res};
                tmp_content.KEYS[pageToEdit] = {};
                setcontent_state(tmp_content)
            }
        }
        fetchData();
    }, [])

    const handleAddContent = (e) =>{
        if(attribute_name !== "" && attribute_text !== ""){

            console.log(attribute_name, attribute_text, settingsLanguage);
            let tmp_content = {...content_state};
            if(!tmp_content.KEYS[pageToEdit]){
                tmp_content.KEYS[pageToEdit] = {}
            }
            tmp_content.KEYS[pageToEdit][attribute_name] = "";
            
            if(!tmp_content[settingsLanguage][pageToEdit]){
                tmp_content[settingsLanguage][pageToEdit] = {}
            }
            tmp_content[settingsLanguage][pageToEdit][attribute_name] = attribute_text;
            setcontent_state(tmp_content)
            setshowSaveWarning(true);
            setattribute_name("");
            setattribute_text("");
        }
        else{
            console.log("error")
        }
    }

    const handleChangetTexInput = (e) =>{
        let id = e.currentTarget.id;
        let value = e.currentTarget.value;
        let key = id.split("-")[0];

        let tmp_content = {...content_state};
        if(!tmp_content[settingsLanguage]) {
            tmp_content[settingsLanguage] = {}
        }
        if(!tmp_content[settingsLanguage][pageToEdit]){
            tmp_content[settingsLanguage][pageToEdit] = {}
        }
        tmp_content[settingsLanguage][pageToEdit][key] = value;
        setcontent_state(tmp_content)

        setshowSaveWarning(true);
    } 

    const saveData = async () =>{
        fetch(process.env.REACT_APP_SERVER_LINK+"content", {
            mode:"cors",
            method: "POST",
            body: JSON.stringify(content_state),
            headers: {
                "Content-type": "application/json",
            },
        });
        setshowSaveWarning(false);
        setdata_isSaved(true);

        setTimeout(function(){setdata_isSaved(false)}, 2000)
    }

	return (
	    <>
        <div className={styles.content}>
            {!pageToEdit ? 
            <>
            <p className={styles.title}>Translations</p>   	
            <p className={styles.pagedescription}>On this page you can adjust all content across the entire website. This can serve for other translations, a different choice of words or maybe even an entire sentence that you want to remove.</p>

            <div className={styles.main}>
                <p className={styles.subtitle}>Choose a page to edit</p>
                <div className={styles.cards}>
                    {
                        Object.keys(contentPages[Object.keys(contentPages)[0]]).map((v, i)=>{
                            return (
                                <div className={styles.card} key={i} id={v} onClick={(e)=>handleClickPage(e)}>
                                    <div className={styles.card_color}></div>
                                    <div className={styles.card_info}>
                                            <p className={styles.card_pagename}>{v}</p>
                                            <p className={styles.card_lastedit}>Edited X months ago</p>
                                    </div>
                                </div>
                            )
                        })
                    }
                </div>
            </div>
            </>
            :
            <>
                <div className={styles.top_buttons}>
                    <p className={styles.backButton} onClick={()=>{setpageToEdit("")}}>Back</p>
                    {showSaveWarning && <div className={styles.warningSave}>Don't forget to save!</div>}
                    <p className={styles.saveButton} onClick={()=>{saveData()}}>{data_isSaved ? "Saved!" : "Save"}</p>
                </div>
                
                <p className={styles.title}>{pageToEdit}</p>   
                <div className={styles.main}>

                    <div className={styles.edit_container}>
                        <div className={styles.language_container}>
                             <p className={styles.language_title}>Page language</p>
                            <Dropdownlist data={["Nederlands", "Frans", "Engels"]} menuPlacement="auto" isSearchable={false} onChange={(v)=>{setsettingsLanguage(v)}} defaultValue/>
                        </div>    
                    </div>

                    <div className={styles.edit_container}>
                        <div className={styles.edit_container_top}>
                            <div className={styles.edit_container_top_left}>
                                <div className={styles.edit_icon} onClick={()=>setshowAddForm(!showAddForm)}>
                                    <img src={edit_icon} alt="icon"/>
                                </div>
                                <p className={styles.main_blockname}>Content {settingsLanguage}</p>
                            </div>
                            <div className={styles.edit_container_top_right} onClick={()=>sethideContent(!hideContent)}>
                                <img src={view_icon} alt="icon"/>
                            </div>
                        </div>

                        <div className={showAddForm ? styles.edit_add_form : styles.edit_add_form_hide}>
                            <div className={styles.edit_content_container}>
                                <p className={styles.edit_subtitle}>Data attribute</p>
                                <input className={styles.inputfield_oneLine} type="text" placeholder="Insert attribute..." value={attribute_name} onChange={(e)=>{setattribute_name(e.currentTarget.value)}}/>
                            </div>
                            <div className={styles.edit_content_container}>
                                <p className={styles.edit_subtitle}>Text</p>
                                <input className={styles.inputfield_oneLine} type="text" placeholder="Insert text..." value={attribute_text} onChange={(e)=>{setattribute_text(e.currentTarget.value)}}/>
                            </div>
                            <div className={styles.edit_form_buttons}>
                                <button className={styles.edit_form_add_button} onClick={()=>handleAddContent()}>Add</button>
                                <button className={styles.edit_form_cancel_button} onClick={()=>setshowAddForm(false)}>Cancel</button>
                            </div>
                            
                        </div>

                        <div className={!hideContent ? styles.edit_content : styles.edit_content_hide} key={settingsLanguage}>
                            {
                                content_state.KEYS[pageToEdit] &&
                                Object.keys(content_state.KEYS[pageToEdit]).map((key, index)=>{
                                    return (
                                        <div className={styles.edit_content_container} key={index}>
                                            <p className={styles.edit_subtitle}>{key}</p>
                                            <input id={key+"-"+settingsLanguage} onChange={(e)=>{handleChangetTexInput(e)}} className={styles.inputfield_oneLine} type="text" placeholder="Insert text..." defaultValue={content_state[settingsLanguage] ? (content_state[settingsLanguage][pageToEdit] && content_state[settingsLanguage][pageToEdit][key]) : ""}/>
                                        </div>
                                    )
                                })
                            }
                        </div>
                    </div>
                </div>
            </>
            }
        </div>
	    </>  
  	);
}